import DocumentManager from '../DocumentManager';
import DocumentsVideos from '../DocumentsVideos';

export default function MediaTab({ childId, childName }) {
  return (
    <div className="space-y-6" data-testid="media-tab">
      <div className="bg-zinc-950/30 border border-zinc-800 backdrop-blur-sm p-6">
        <DocumentManager 
          childId={childId}
          childName={childName}
        />
      </div>
      <div className="bg-zinc-950/30 border border-zinc-800 backdrop-blur-sm p-6">
        <DocumentsVideos 
          childId={childId}
          childName={childName}
        />
      </div>
    </div>
  );
}
